import { StyleSheet } from 'aphrodite'

import headers from './headers'
import form from './form'
import user from './user'

export default {
  headers: StyleSheet.create(headers),
  form: StyleSheet.create(form),
  user: StyleSheet.create(user)
}



// WEBPACK FOOTER //
// ./src/components/Community/partials/CommunityCreator/style/ColorBlind/index.js